import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Card, SummaryTable } from '../../molecules';
// TODO add bottom action button, as soon as we now use cases
export const DataCard = forwardRef(function DataCard({ data, actions, title, stripes }, ref) {
    return (_jsx(Card, { ref: ref, actions: actions, title: title, children: _jsx(SummaryTable, { data: data, stripes: stripes }) }));
});
